import router from "@/router/index.js";
import NProgress from 'nprogress'
import useUserStore from "@/store/modules/user.js";
import useRoutesStore from "@/store/modules/routes.js";

NProgress.configure({ showSpinner: false });

const whiteList = ['/login', '/register'];
// https://router.vuejs.org/zh/api/interfaces/Router.html
router.beforeEach(async (to, from, next) => {
    NProgress.start()
    const userStore = useUserStore();
    const routesStore = useRoutesStore();

    if (userStore.token) {
        // 判断用户是否有路由信息
        if (routesStore.routes.length > 0) {
            next();
        } else {
            try {
                // 获取用户信息
                await userStore.getDetail();
                // 获取路由数据
                const accessRoutes = await routesStore.getRoutes();
                // 动态添加路由
                accessRoutes.forEach((item) => {
                    router.addRoute(item);
                });
                // 确保导航不会因为动态路由添加后留在旧的状态
                next({ ...to, replace: true });
            } catch (routerErr) {
                // 获取用户信息失败，执行注销并重定向到登录页面
                try {
                    await userStore.logout();
                } catch (logoutErr) {
                    message.error('Failed to log out: ' + logoutErr);
                } finally {
                    next(`/login?redirect=${to.fullPath}`); // 重定向到登录页
                }
            } finally {
                NProgress.done();
            }
        }
    } else {
        // 如果访问的路径在白名单中，直接放行
        if (whiteList.includes(to.path)) {
            next();
        } else {
            // 否则重定向到登录页
            next(`/login?redirect=${to.fullPath}`);
        }
    }
})

router.afterEach(() => {
    NProgress.done()
})